import { createStore } from "vuex";
import { tasksService } from "@/services/tasksService";
import axios from "axios";

// get token from localstorage
  const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export default createStore({
  state: {
    user: null,
    notifications: [],
    token: localStorage.getItem("token") || null,
    userSubscription :null,
    selectedGroupId: null,
  },
  getters: {},
  mutations: {
    getNotifications(state, allNotifications) {
      state.notifications = allNotifications;
    },
    getCurrentUser(state, userInfo) {
      state.user = userInfo;
    },
    UPDATE_USER_PROFILE(state, newImageUrl) {
      if (state.user) {
        state.user.profile_img = newImageUrl;  
      }
  },
  getSubInfos(state, status) {
      state.userSubscription = status;
    },
    SET_SELECTED_GROUP(state, groupId) {
      state.selectedGroupId = groupId;
    },
},
  actions: {
    async getNotifications({ commit }) {
      try {
        const res = await tasksService.getTaskNotification();
        const data = res && res.data ? res.data : [];
        commit("getNotifications", data);
      } catch (err) {
        console.log("error:", err);
      }
    },
    async getCurrentUser({ commit }) {
      try {
        const res = await axios.get(
          "https://app-dc37e42a-38d5-480d-9a3d-1349ea33f548.cleverapps.io/api/users/profile",
          getAuthHeaders(),
        );
        const data = res && res.data ? res.data : [];
        commit("getCurrentUser", data);
      } catch (err) {
        throw err;
      }
    },


 async getSubInfos({ commit, state, dispatch }) {
  try {
    if (!state.user) {
      await dispatch("getCurrentUser");
    }

    
    const res = await tasksService.checkServerSubscription();
    commit("getSubInfos", res);

  } catch (err) {
    console.error("error in fetching subscription:", err);
  }
},

updateGroup({ commit }, groupId) {
      commit('SET_SELECTED_GROUP', groupId);
    },


},
  modules: {},
});
